import { formatSabilOutstandingTypeLabel } from "./sabil-outstanding-type-label";

/** `kind` choices for the broadcast list filter/column — mirrors the tabs in BroadcastModeFields. */
export const BROADCAST_KIND_CHOICES: { id: string; name: string }[] = [
  { id: "TEMPLATE", name: "Template" },
  { id: "MIQAAT_RSVP", name: "Miqaat RSVP" },
  { id: "EVENT_RSVP", name: "Event RSVP" },
  { id: "FMB_OUTSTANDING", name: "FMB Outstanding" },
  { id: "SABIL_OUTSTANDING", name: "Sabil Outstanding" },
  { id: "MUTTAVATTEEN_OUTSTANDING", name: "Mutawatteen Outstanding" },
];

export function formatBroadcastKindLabel(kind: string | null | undefined): string {
  const match = BROADCAST_KIND_CHOICES.find((choice) => choice.id === kind);
  return match ? match.name : String(kind ?? "—");
}

/** `sabilType` choices for the broadcast list filter — only meaningful for the two outstanding kinds. */
export const SABIL_TYPE_FILTER_CHOICES = (
  ["CHULA", "ESTABLISHMENT", "MUTTAVATTEEN", "MUTTAVATTEEN_YEARLY"] as const
).map((id) => ({ id, name: formatSabilOutstandingTypeLabel(id) }));

/** Compact "kind · sub-type · template" line for the mobile card list. */
export function describeBroadcastListSecondaryText(record: {
  kind?: string | null;
  filterCriteria?: { sabilType?: string } | null;
  templateName?: string | null;
}): string {
  const parts = [formatBroadcastKindLabel(record.kind)];
  const sabilType = record.filterCriteria?.sabilType;
  if (sabilType) {
    parts.push(formatSabilOutstandingTypeLabel(sabilType));
  }
  if (record.templateName) {
    parts.push(record.templateName);
  }
  return parts.join(" · ");
}
